import React, { useEffect, useState } from 'react';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://demo.myssa.net/api';

const Card21 = ({ title }) => {
  const [value, setValue] = useState(null);

  useEffect(() => {
    fetch(`${API}/taches`)
      .then(res => res.json())
      .then(data => {
        const filtered = data.filter(
          row => row["Département"] === "APPRO" && row["Statut"] !== "soldé"
        );
        setValue(filtered.length);
      })
      .catch(err => { console.error('Erreur récupération taches:', err); setValue(0); });
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '120px', width: '220px', backgroundColor: '#ffffff', border: '1px solid #f0ece2', borderRadius: '14px', padding: '16px 20px', boxSizing: 'border-box', position: 'relative', overflow: 'hidden', cursor: 'pointer' }}>

      {/* Barre accent — VIOLET (tâches) */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: 'linear-gradient(90deg, #3c3489, #a78bfa)', borderRadius: '14px 14px 0 0' }} />

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div style={{ width: '28px', height: '28px', backgroundColor: '#ede9fe', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="8" y1="6" x2="21" y2="6"/>
            <line x1="8" y1="12" x2="21" y2="12"/>
            <line x1="8" y1="18" x2="21" y2="18"/>
            <polyline points="3 6 4 7 6 5"/>
            <polyline points="3 12 4 13 6 11"/>
            <polyline points="3 18 4 19 6 17"/>
          </svg>
        </div>
        <span style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontSize: '15px', fontWeight: '500', color: '#8b7b64', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          Tâches APPRO
        </span>
      </div>

      <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: '32px', fontWeight: '600', color: '#0f172a', lineHeight: 1, textAlign: 'center' }}>
        {value === null ? <span style={{ fontSize: '20px', color: '#cbd5e1' }}>—</span> : value}
      </div>
    </div>
  );
};

export default Card21;